import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CenterContainer } from './styles';
import { EKYC_RFI_EKYC_SERVICE_DOWN } from './utils';
import { CommonButton } from '@Components';
import { BLUE_WARNING_ICON } from '@Images';
import { DASHBOARD_URL } from '@Utils/constants';
import { getRfiCmsData } from '@Redux/selectors';

const EkycServiceDownPage: React.FC = () => {
  const navigate = useNavigate();
  const serviceDownPageCMSData = useSelector(getRfiCmsData)?.ekycRFI?.serviceDownPage;
  const { heading, description, goToHomeCTA } =
    serviceDownPageCMSData ?? EKYC_RFI_EKYC_SERVICE_DOWN;

  const handleGoToHome = () => {
    navigate(DASHBOARD_URL);
  };
  return (
    <CenterContainer>
      <div className="innerContainer">
        <div className="img">
          <img src={BLUE_WARNING_ICON} alt="Retrieve Failure Logo" />
        </div>
        <div className="heading">{heading}</div>
        <div className="description">{description}</div>
        <div className="btnWrapper">
          <CommonButton text={goToHomeCTA} onClick={handleGoToHome} type="link" />
        </div>
      </div>
    </CenterContainer>
  );
};

export default EkycServiceDownPage;
